import { BrowserRouter, Route, Routes } from "react-router-dom"
import { AppShell } from "./app/AppShell"
import { EmpresaProvider } from "./app/context/EmpresaContext"
import { ProtectedRoute } from "./app/ProtectedRoute"
import { LandingPage } from "./pages/LandingPage"
import { LoginCallbackPage } from "./pages/LoginCallbackPage"
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage"
import { LoginPage } from "./pages/LoginPage"
import { RequirePasswordUpdated } from "./app/RequirePasswordUpdated"
import { ChangePasswordPage } from "./pages/app/ChangePasswordPage"
import { PrivacidadePage } from "./pages/PrivacidadePage"
import { DesenvolvedoresPage } from "./pages/DesenvolvedoresPage"
import { TermosPage } from "./pages/TermosPage"
import { GestaoPage } from "./pages/app/GestaoPage"
import { SuperAdminPage } from "./pages/app/SuperAdminPage"
import { AuditoriaPage } from "./pages/app/AuditoriaPage"
import { CertificadosPage } from "./pages/app/CertificadosPage"
import { DashboardPage } from "./pages/app/DashboardPage"
import { DfePage } from "./pages/app/DfePage"
import { IaPage } from "./pages/app/IaPage"
import { NfePage } from "./pages/app/NfePage"
import { NfeFaixaPage } from "./pages/app/NfeFaixaPage"
import { PlanosPage } from "./pages/app/PlanosPage"
import { WebhooksPage } from "./pages/app/WebhooksPage"

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
        <Route path="/login/callback" element={<LoginCallbackPage />} />
        <Route path="/desenvolvedores" element={<DesenvolvedoresPage />} />
        <Route path="/termos" element={<TermosPage />} />
        <Route path="/privacidade" element={<PrivacidadePage />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <EmpresaProvider>
                <RequirePasswordUpdated />
              </EmpresaProvider>
            </ProtectedRoute>
          }
        >
          <Route path="alterar-senha" element={<ChangePasswordPage />} />
          <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="planos" element={<PlanosPage />} />
          <Route path="nfe" element={<NfePage />} />
          <Route path="nfe/faixa" element={<NfeFaixaPage />} />
          <Route path="certificados" element={<CertificadosPage />} />
          <Route path="dfe" element={<DfePage />} />
          <Route path="webhooks" element={<WebhooksPage />} />
          <Route path="ia" element={<IaPage />} />
          <Route path="auditoria" element={<AuditoriaPage />} />
          <Route path="gestao" element={<GestaoPage />} />
          <Route path="super-admin" element={<SuperAdminPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
